import React from 'react'
import SwitchAccounts from './SwitchAccounts'
import config from '../../config'
import logout from '../utils/logout'
import useParams from '../utils/useParams'
import { css } from 'emotion'
import { Link } from './Link'
import { matchPath, withRouter } from 'react-router-dom'
const { colors, components } = require('@peachjar/components')
const { Profile } = components
const { REACT_APP_ACCOUNTS_APP_URL } = config

const helpPageLink = config.REACT_APP_PEACHJAR_SUPPORT_URL
                     || 'https://peachjar.com/contact-us.html'
                    
const PARENT_ROUTES = Object.freeze({
  parentAccountInfo: '/parent/account-information',
  parentEmailNotificationsManage: '/parent/email-notifications/manage',
  parentEmailNotifications: '/parent/email-notifications', 
})

const ProfileDropdown = ({
  userId,
  entityName,
  firstName,
  lastName,
  emailAddress,
  hierarchyType,
  avatarURI,
  linkedAccounts,
  flags,
  getUserType,
  hideProfileLinks = false,
  history
}) => {
  const { flyerId, resource, resourceId } = useParams(history, '/flyers/:flyerId/:resource(schools|districts)/:resourceId')
  const queryParams = `?flyer=${flyerId}&resource=${resource}&resourceId=${resourceId}`
 
  const pathname = history.location.pathname
  const dropDownConfig = {
    activeLinks: [
      PARENT_ROUTES.parentAccountInfo,
      PARENT_ROUTES.parentEmailNotifications,
    ],
    profileLinks: [
      {
        text: 'Account Information',
        link: 
        `${REACT_APP_ACCOUNTS_APP_URL}${PARENT_ROUTES.parentAccountInfo}${queryParams}`,
        linkType: 'external',
        requiresRoleCheck: true,
        allowedRoles: ['parent', 'family'],        
      },
      {
        text: 'Notifications',
        link: `${REACT_APP_ACCOUNTS_APP_URL}${PARENT_ROUTES.parentEmailNotifications}${queryParams}`,
        linkType: 'external',
        requiresRoleCheck: true,
        allowedRoles: ['parent', 'family'],        
      },
      {
        text: 'Help',
        link: helpPageLink,
        linkType: 'external',
        requiresRoleCheck: false,
        allowedRoles: [],        
      },
    ],
  }
  // @ts-ignore
  const isPortalNavEnabled = flags.portal_nav === 1
  const { activeLinks, profileLinks } = dropDownConfig

  const getLink = (
    content,
    link,
    linkType,
    index,    
  ) => {
    if (linkType === 'internal') {
      return (
        <Link key={index} to={link} className={classNames.profileLink}>
          {content}
        </Link>
      )
    }    
    return (
      <a
        href={link}
        key={index}
        className={classNames.profileLink}        
        >
        {content}
      </a>
    )
  }
  const isDropDownActive = activeLinks.includes(pathname)

  const getUserName = () => `${firstName} ${lastName}`.trim()

  return (
    <Profile
      name={firstName}
      emailAddress={emailAddress}
      profilePictureURI={avatarURI}
      entityName={entityName}
      fullName={getUserName()}
      data-testid='menu-profile-dropdown'
      className={`${classNames.dropdownTrigger} ${
        isPortalNavEnabled && isDropDownActive && userId !== '' ? classNames.dropDownActive : ''
      }`}
    >
      {userId !== '' && (
        <SwitchAccounts
          userId={userId}
          fullName={getUserName()}
          linkedAccounts={linkedAccounts}
          getUserType={getUserType}
        />
      )}
      {isPortalNavEnabled && (
        <ul className={classNames.profileMenu}>
          {!hideProfileLinks && profileLinks.map(
            (
              {
                text,
                link,
                linkType,
                allowedRoles,
                requiresRoleCheck,
                isTargetBlank
              },
              idx
            ) => {
                if (
                  requiresRoleCheck &&
                  !allowedRoles.includes(hierarchyType)
                ) {
                  return null
                }
                const isActive = matchPath(pathname, {
                  path: link,
                  exact: true,
                })
                const liContent = (
                  <li
                    className={`${classNames.profileLinkList} ${
                      isActive ? classNames.activeLink : ''
                    }`}
                  >
                    {text}
                  </li>
                )

                return getLink(liContent, link, linkType, idx, isTargetBlank)

            }
          )}
          <a
            className={classNames.profileLink}
            href={void(0)}
            onClick={() => logout()}
            tabIndex={0}
            data-testid='click-profiledropdown-logout'
          >
            <li className={classNames.profileLinkList}>Log Out</li>
          </a>
        </ul>
      )}
    </Profile>
  )
}

const classNames = {
  dropdownTrigger: css`
    border-left: 1px solid ${colors.prussian};
    height: 100%;
    & svg {
      fill: #fff !important;
    }
    /* & .MuiSvgIcon-root {
      fill: #fff !important;
    } */
    & .MuiButton-label-2 {
      span {
        color: #fff;
      }
    }
    & hr {
      border: 0;
      border-top: 1px solid rgba(0,0,0,.1);
    }
    div[role=tooltip] {
      z-index: 999;
    }

    @media (max-width: 480px) {
      & button {
        min-width: 50px;
        width: inherit !important;
        & > span > div > span {          
          display: none;
        }
        & > span > svg {
          display: none;
        }       
      }
      div[role=tooltip] {
        left: -42%
      }
    }
  `,
  dropDownActive: css`
    border-bottom: 4px solid ${colors.leaf};
  `,
  profileMenu: css`
    list-style-type: none;
    padding: 8px;
  `,
  profileLink: css`
    &:hover {
      text-decoration: none;
    }
  `,
  profileLinkList: css`
    color: ${colors.prussian};
    padding: 17px 15px;
    height: 54px;
    font-size: 13px;
    border-radius: 3px;

    &:hover {
      text-decoration: none;
      background-color: #ededed;
    }
  `,
  activeLink: css`
    border-left: 4px solid ${colors.leaf};
    font-weight: bold;
    background-color: rgba(0, 0, 0, 0.03);
  `,
}

export default withRouter(ProfileDropdown)



// WEBPACK FOOTER //
// ./src/shared/components/ProfileDropDown.js